/**
 * 优惠券UI类型
 * @description 通过各种计算得出使用那种 UI 类型
 */
export enum ECouponUIType {
  /**
   * 正常
   */
  NORMAL = 1,
  /**
   * 倒计时
   */
  COUNT_DOWN = 2,
  /**
   * 禁用
   */
  DISABLED = 3,

  /**
   * 运费券
   */
  SHIPPING = 4,
}

/**
 * 优惠券是否首单
 */
export enum EIsFirstOrder {
  /**
   * 首单
   */
  FIRST_ORDER = 1,
  /**
   * 非首单
   */
  NOT_FIRST_ORDER = 2,
}

/**
 * 优惠券是否长期有效
 */
export enum EIsLongTerm {
  /**
   * 长期有效
   */
  LONG_TERM = 1,
  /**
   * 非长期有效
   */
  NOT_LONG_TERM = 2,
}

/**
 * 优惠券倒计时类型
 */
export enum ECountDown {
  /**
   * 倒计时
   */
  COUNT_DOWN = 1,
  /**
   * 不倒计时
   */
  NOT_COUNT_DOWN = 2,
}

/**
 * 优惠券折扣类型
 */
export enum ECouponDiscountType {
  /**
   * 折扣
   */
  DISCOUNT = 1,
  /**
   * 满减
   */
  FULL_REDUCTION = 2,
  /**
   * 指定价
   */
  SPECIAL_PRICE = 3,
  /**
   * 免费
   */
  FREE = 4,
  /**
   * 特殊优惠
   */
  SPECIAL_DISCOUNT = 5,
}

export enum ECouponStatus {
  /**
   * 正常
   */
  NORMAL = 1,
  /**
   * 已结束
   */
  END = 2,
}

export enum ECouponButtonType {
  /**
   * 前往购物, get
   */
  GET = 1,
  /**
   * 立即使用, shop
   */
  SHOP = 2,
}

export enum ECouponType {
  /**
   * 优惠券
   */
  DISCOUNT = 1,

  /**
   * 兑换券
   */
  EXCHANGE = 3,

  /**
   * 运费券
   */
  SHIPPING = 4,
}
